// extracted by mini-css-extract-plugin
module.exports = {"root":"Search_root__1uo2p","input":"Search_input__20r6t","btn":"Search_btn__mNdYX"};